import { FontStyles } from "../utils/font-styles.ts";
import { cn } from "../utils/cn.ts";
export const TagPill = (props: { text: string; colourClass: string }) => {
  /*
       // Padding explanation:
       // This is a fix for the text not being vertically centered perfectly
       // until https://caniuse.com/css-text-box-trim is supported in all browsers which solves this issue
       // if we ever provide different font sizes for the tag pill, we will need to adjust this value accordingly
       // https://medium.com/@mayurnandu195/what-i-learned-after-3-hours-of-typography-debugging-6d12f0ac961f
    */
  return (
    <div
      className={cn(
        FontStyles["body-s"],
        props.colourClass,
        "!leading-none",
        "text-nowrap text-neutral-white rounded-sm px-2.5",
        "font-bold uppercase pt-1.5 pb-[5px] md:pb-[4px] md:pt-[7px]",
        "tracking-[0.28px]",
      )}
    >
      {props.text}
    </div>
  );
};
